import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center gap-2" }
const _hoisted_2 = { class: "relative flex items-center justify-center" }
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center text-xl w-72 min-h-10 rounded-xl"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "text-base font-bold uppercase"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-base uppercase" }

import reload from "@/assets/images/misc/reload.svg";
import EventBus from "@/plugins/EventBus";
import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import textImage from "@/assets/images/misc/text.svg";
import CloseButton from "@/components/CloseButton.vue";
import { useGameTracking } from "@/composables/useGameTracking";
import { useGlobalStore } from "@/stores/global";
import arrow from "@/assets/images/misc/Glyph.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'PushButton',
  emits: ["isStopped"],
  setup(__props, { emit: __emit }) {

const globalStore = useGlobalStore();
const { kpiTracker, session } = useGameTracking();

const emit = __emit;
const imageSelected = ref(false);
const clickCounter = ref(0);
let keyHeldDown = false;

const triggerMethod = () => {
  if (imageSelected.value || globalStore.currentStep === "ageCheck") {
    globalStore.playTapSound();
  } else {
    globalStore.playBuzzerSound();
    if (!kpiTracker.voucherRedeemed.value) {
      kpiTracker.setVoucherRedeemed(true);
      session
        .updateSessionProgress(kpiTracker.getKpiData(), {
          step: "move_stopped",
        })
        .catch((error) => {
          console.error("[PushButton] Error while tracking move stop:", error);
        });
    }
  }

  imageSelected.value = !imageSelected.value;
  EventBus.emit("startGame", imageSelected.value);
  emit("isStopped", imageSelected.value);

  clickCounter.value++;

  if (clickCounter.value === 2) {
    kpiTracker.incrementTimesPlayed();
    clickCounter.value = 0;
  }
};

const handleKeydown = (event: KeyboardEvent) => {
  if (!keyHeldDown && (event.key === "b" || event.key === "Enter")) {
    keyHeldDown = true;
    triggerMethod();
  }
};

const handleKeyup = (event: KeyboardEvent) => {
  keyHeldDown = false;
};

const handleButtonClick = () => {
  globalStore.changeStep("peopleCheck");
  globalStore.playTapSound();
  kpiTracker.resetGame();
  globalStore.resetGame(kpiTracker.selectedPerson.value);
};

const handleEnoughClick = () => {
  globalStore.changeStep("ageCheck");
  globalStore.playTapSound();
  globalStore.setShouldShowDailyLimitScreen(false);
  globalStore.setCapturedPhotoFile(null);
  globalStore.setCapturedPhotoDataUrl(null);
  globalStore.setUploadedPhotoItemId(null);
  globalStore.setRaffleResult(null);
  kpiTracker.resetGame();
  kpiTracker.resetTrackingData();
  globalStore.resetGame(kpiTracker.selectedPerson.value);
};

watch(
  () => globalStore.timesLeftToPlay,
  async (newValue) => {
    if (newValue <= 0) {
      if (kpiTracker.gamePlayTimeStart.value !== null) {
        const endTime = Date.now();
        const playTimeSeconds = Math.floor(
          (endTime - kpiTracker.gamePlayTimeStart.value) / 1000
        );
        kpiTracker.setGamePlayTimeSeconds(playTimeSeconds);
      }
      // Keep progress at 2 (game_started) - don't change it
      // Update session with progress "game_finished" and mark_session_as_finished: true
      // This will set has_finished_game = true in the backend
      console.log(
        "[PushButton] Updating session with progress 'game_finished' and mark_session_as_finished: true (has_finished_game will be set to true by backend)"
      );
      await session.updateSessionProgress(
        kpiTracker.getKpiData(),
        { step: "game_finished" },
        true
      );
      globalStore.setRaffleResult(null);

      globalStore.changeStep("photoCapture");
    }
  }
);

onMounted(() => {
  window.addEventListener("keydown", handleKeydown);
  window.addEventListener("keyup", handleKeyup);
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", handleKeydown);
  window.removeEventListener("keyup", handleKeyup);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (triggerMethod())),
        class: _normalizeClass(["relative z-10 flex items-center justify-center h-10 font-bold leading-5 text-white uppercase rounded-xl border-jm_orange w-72", _unref(globalStore).timesLeftToPlay <= 0 ? '' : 'bg-jm_orange'])
      }, [
        (_unref(globalStore).timesLeftToPlay <= 0)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: handleEnoughClick,
              class: "flex items-center justify-center px-2 py-2 text-xl w-72 bg-jm_orange rounded-xl"
            }, _toDisplayString(_ctx.$t("game_controls.got_it")), 1))
          : (imageSelected.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.$t("game_controls.play_again")) + " ", 1),
                _createElementVNode("img", {
                  src: _unref(reload),
                  class: "w-4 ml-3"
                }, null, 8, _hoisted_4)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("game_controls.push_for_your_move")), 1))
      ], 2)
    ]),
    (_unref(globalStore).timesLeftToPlay > 0 && !imageSelected.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flex flex-row items-center justify-center h-10 gap-2 px-4 py-2 font-bold text-white border-2 border-jm_white w-72 rounded-xl bg-white/10 backdrop-blur-lg",
          onClick: handleButtonClick
        }, [
          _createElementVNode("img", {
            class: "w-3",
            src: _unref(arrow)
          }, null, 8, _hoisted_6),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("game_controls.back")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})